import React, {FC, useState} from "react";
import Logo from "components/Logo/Logo";
import Navigation from "components/Navigation/Navigation";
import SearchDropdown from "./SearchDropdown";
import ButtonPrimary from "components/Button/ButtonPrimary";
import ButtonSecondary from "components/Button/ButtonSecondary";
import MenuBar from "components/MenuBar/MenuBar";
import DarkModeContainer from "containers/DarkModeContainer/DarkModeContainer";
import {auth} from "configs/firebase-config";
import {onAuthStateChanged, signOut} from "firebase/auth";
import {useHistory} from "react-router";
import NotifyDropdown from "./NotifyDropdown";
import AvatarDropdown from "./AvatarDropdown";
import {MoonIcon} from "@heroicons/react/solid";
import metamask from "/images/metamask.svg";
import { Link } from "react-router-dom";
import {displayToast, toastType} from "../../global/Functions";

export interface MainNav1Props {
  isTop: boolean;
}

const MainNav1: FC<MainNav1Props> = ({ isTop}) => {
  let history = useHistory();
  const [user, setUser] = useState<any>();

  onAuthStateChanged(auth, (user) => {
    setUser(user);
  });

  const handleSignOut = () => {
    try{
      signOut(auth).then(() => {
        history.replace("/login");
      });
      displayToast("See you soon!", toastType.info);
    } catch (error) {
      displayToast("Something went wrong", toastType.error);
    }
  }
  return (
    <div
      className={`MainNav1 relative z-10 ${
        isTop ? "onTop " : "notOnTop backdrop-filter"
      }`}
    >
      <div className="container py-5 relative flex justify-between items-center space-x-4 xl:space-x-8">
        <div className="flex justify-start flex-grow items-center space-x-4 sm:space-x-10 2xl:space-x-14">
          <Logo />
          <Navigation />
        </div>
        <div className="flex-shrink-0 flex items-center justify-end text-neutral-700 dark:text-neutral-100 space-x-1">
          <div className="hidden items-center xl:flex space-x-1">
            <DarkModeContainer />
            <SearchDropdown />
            {!user ?
              <>
                <div className="px-1" />
                <ButtonPrimary href="/login">Login</ButtonPrimary>
              </>
              :
              <>
                <NotifyDropdown />
                <div className="px-1" />
                <AvatarDropdown />
              </>
            }
          </div>
          <div className="flex items-center xl:hidden">
            {!user ?
              <>
                <ButtonPrimary href="/login">Sign in</ButtonPrimary>
                <div className="px-1"/>
              </>
              :
              <>
                <ButtonPrimary href="/login" onClick={handleSignOut}>Sign Out</ButtonPrimary>
                <div className="px-1"/>
              </>
            }
            <MenuBar />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MainNav1;
